// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-snack[data-v-33a431dc] .v-snack__wrapper {\n  padding-right: 8px;\n}\n.c-snack[data-v-33a431dc] .v-snack__wrapper .c-snack__content {\n  font-size: 1rem;\n  font-weight: bold;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
